import { Box, ButtonAsync, FormControl, FormControlError, FormControlErrorText, FormControlLabel, FormControlLabelText, Heading, Input, InputField, Text, VStack, } from '../../primitives';
import React, { useState } from 'react';
import { useRoutingLib } from '../../../hooks';
import { ButtonText } from '@gluestack-ui/themed';
export const ForgotPasswordPrompt = ({ onSubmit, }) => {
    const [employeeNumber, setEmployeeNumber] = useState('');
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [serverError, setServerError] = useState(null);
    const { useNavigate } = useRoutingLib();
    const navigate = useNavigate();
    const goBackToLogin = () => navigate('/auth/login');
    const onInput = (value) => {
        setEmployeeNumber(value);
    };
    const onPressSubmit = async () => {
        setPending(true);
        try {
            await onSubmit(employeeNumber);
            setSuccess(true);
            setPending(false);
        }
        catch (error) {
            setPending(false);
            // Server doesn't seem to give errors (no hints), but just in case
            setServerError(error);
        }
    };
    return (React.createElement(Box, { sx: {
            _web: { w: '$92' },
            _ios: { w: '$full' },
            _android: { w: '$full' },
        }, h: "$76", alignSelf: "center" },
        React.createElement(VStack, { h: "$full", alignItems: "center", justifyContent: "space-between" },
            React.createElement(VStack, { w: "$full", space: "2xl" },
                React.createElement(VStack, { alignItems: "center", mx: "$2", space: "sm" },
                    React.createElement(Heading, { size: "xl" }, "Forgot password"),
                    React.createElement(Text, { size: "lg", textAlign: "center", w: "$70" }, success
                        ? 'Success! If your employee number is registered, you’ll receive a text with your temporary password shortly.'
                        : 'Enter your employee number')),
                !success && (React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: !!serverError },
                    React.createElement(FormControlLabel, null,
                        React.createElement(FormControlLabelText, null, "Employee number")),
                    React.createElement(Input, { size: "lg", isDisabled: pending },
                        React.createElement(InputField, { value: employeeNumber, onChangeText: onInput, autoComplete: "username", autoCapitalize: "none", type: "text", placeholder: "Enter your employee number" })),
                    React.createElement(FormControlError, null,
                        React.createElement(FormControlErrorText, null, employeeNumber ? 'Invalid employeeNumber' : 'Empty field'))))),
            React.createElement(VStack, { w: "$70", space: "4xl", alignItems: "center" },
                success && (React.createElement(Text, { textAlign: "center" }, "Contact Brendan Smiley with IT at 602-596-5579 for questions and assistance")),
                React.createElement(ButtonAsync, { pending: pending, onPress: success ? goBackToLogin : onPressSubmit, w: "$40", size: "lg" },
                    React.createElement(ButtonText, null, success ? 'Return to sign in' : 'Submit'))))));
};
